






import { Component, Vue } from 'vue-property-decorator';
import ConfigModlue from '@/store/modules/config';

@Component
export default class Fixedmode extends Vue {
  // 固定表示モードのURI
  private uri = '';

  activated() {
    this.uri = ConfigModlue.fixedmodeUri;
  }
}
